<template>
   <HeaderDash />
   <SideMenu /> 
   <ContentAddOrganization /> 
</template>
<script>
// Importando los componententes pertenecientes a esta vista
import HeaderDash from '@/components/worker/dashboard/HeaderDash.vue'
import SideMenu from '@/components/worker/dashboard/SideMenu.vue'
import ContentAddOrganization from '@/components/worker/dashboard/modules/users/organization/ContentAddOrganization.vue'

export default 
{
  name: 'AddOrganization',
  components: 
  {
    HeaderDash,
    SideMenu,
    ContentAddOrganization
  }
}
</script>
<style>

</style>
